import { Box } from "@mui/material";
import { BoxFC, BoxFR } from "components/BoxCustom";
import GoogleMapWrapper from "components/GoogleMapWrapper/GoogleMapWrapper";
import { useCallback, useMemo, useState } from "react";

const GPSTestPage = () => {
  const [dialogData, setDialogData] = useState({ Lat: 0, Lng: 0, Rad: 0, points: [] })


  const latLngData = useMemo(() => {
    return {
      lat: dialogData.Lat,
      lng: dialogData.Lng,
      rad: dialogData.Rad,
      points: dialogData.points
    }
  }, [dialogData.Lat, dialogData.Lng, dialogData.Rad, dialogData.points])

  const setLatLngData = useCallback((latLngData) => {

    const { lat, lng, rad, points } = latLngData
    setDialogData((o) => ({ ...o, Lat: lat, Lng: lng, Rad: rad, points: points }))
  }, [])

  return (
    <BoxFR>
      <Box width={900} height={800}>
        <GoogleMapWrapper latLngData={latLngData} setLatLngData={setLatLngData} initCenter={null} />
      </Box>
      <BoxFC>
      </BoxFC>
    </BoxFR>
  );
};

export default GPSTestPage;
